/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_DOMAIN_APPROVER_ECU_REQUEST,
  FETCH_DOMAIN_APPROVER_ECU_SUCCESS,
  FETCH_DOMAIN_APPROVER_ECU_FAILURE,
} from "./DomainApproverEcuTypes";

const initialState = {
  ecu: [],
  loading: false,
  error: null,
};

const domainApproverEcuTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DOMAIN_APPROVER_ECU_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_DOMAIN_APPROVER_ECU_SUCCESS:
      return {
        ...state,
        loading: false,
        ecu: action.payload || [],
        error: null,
      };
    case FETCH_DOMAIN_APPROVER_ECU_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default domainApproverEcuTypesReducer;
